module.exports = __webpack_public_path__ + "img/jn.6cc6a168.png";